import { mapRef } from "./mapRef.js";
/**
 * A convenience function that creates a reference which falls back to a specified value
 * when the source reference's value is `null` or `undefined`.
 */
export function fallbackRef(source, fallback) {
    return mapRef(source, (value) => value ?? fallback);
}
